import { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import * as API from '../api/merchant-invitation/index.api';
import * as Types from '../api/merchant-invitation/types.api';

//
//

const key = 'programme-invitation';

//

export const useInvitationByIdGet = createQuery<
  Types.InvitationResponse,
  Types.InvitationByIdPayload,
  AxiosError<{ message: string }>
>({
  queryKey: [key],
  fetcher: (params) => API.getInvitationByIdAPI(params),
});
